import { useTranslation } from '@splitfiesta/i18n';
import { Button, Card } from '@splitfiesta/ui';

export type StoppedLinkProps =
  | { kind: 'stopped'; title?: string; payer?: string }
  | { kind: 'notFound' }
  | { kind: 'error'; onRetry: () => void };

/** The page when there is nothing to pick: closed, unknown, or not loaded. */
export function StoppedLink(props: StoppedLinkProps) {
  const { t } = useTranslation('claimLink');

  return (
    <Card noHoverEffect className="text-center">
      {props.kind === 'stopped' ? (
        <>
          {props.title ? (
            <h1 className="break-words text-xl font-bold text-gray-900 dark:text-gray-50">
              {props.title}
            </h1>
          ) : null}
          <p className="mt-2 text-base text-gray-700 dark:text-gray-300">
            {props.payer
              ? t('stopped.closed', { payer: props.payer })
              : t('stopped.gone')}
          </p>
        </>
      ) : props.kind === 'notFound' ? (
        <h1 className="text-lg font-semibold text-gray-900 dark:text-gray-50">
          {t('notFound')}
        </h1>
      ) : (
        <>
          <h1 className="text-lg font-semibold text-gray-900 dark:text-gray-50">
            {t('loadError')}
          </h1>
          <Button
            type="button"
            variant="primary"
            onClick={props.onRetry}
            className="mt-4 min-h-11"
          >
            {t('retry')}
          </Button>
        </>
      )}
    </Card>
  );
}

export default StoppedLink;
